import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'psc-readonly-value',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './readonly-value.component.html',
})
export class ReadonlyValueComponent {
  @Input() value: string | number;
}
